import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Google from "../components/google 1.svg";
import AuthLayout, { EmailField, PasswordField } from "../components/AuthLayout";
import AccountSelector from "../components/AccountSelector";
import ContactDialog from "../components/ContactDialog";
import Icon from "../components/Icon";
import { TermsLink } from "../components/TermsDialog";
import request from "../core/request";
import { encrypt, getDevAppLink } from "../utils";
import { env } from "../utils/const";
import { validateEmail, validatePassword } from "../utils/validator";
const { NODE_ENV } = process.env;
const Login = () => {
  const { REACT_APP_AUTH_PAGE_URL } = env;
  const { REACT_APP_STATIC_PAGE_URL } = env;
  const { REACT_APP_GOOGLE_AUTH_URL } = env;
  const { REACT_APP_GOOGLE_CLIENT_ID } = env;

  const [state, setState] = useState({
    email: "",
    emailError: "",
    password: "",
    passwordError: "",
    checkError: "",
    showPassword: false,
  });
  const [loading, setLoading] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const [remember, setRemember] = useState(false);
  const [check, setCheck] = useState(true);
  const history = useHistory();

  // Multi-account state
  const [multiAccountData, setMultiAccountData] = useState(null);

  const handleState = (value, key) => {
    setState({ ...state, [key]: value, [key + "Error"]: "" });
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get("code");

  useEffect(() => {
    const getCodeFromURL = async () => {
      if (code) {
        let { data, status } = await request.post(`/user/auth`, {
          code: code,
        });
        if (status > 400) {
          toast.error(data?.message);
          setTimeout(function () {
            window.location.href = REACT_APP_AUTH_PAGE_URL;
          }, 5000);
        }
        if (status >= 200 && status < 400) {
          let url = data?.data?.reDirectUrl;
          window.location.href = url;
        }
      } else {
        console.log("Code parameter not found in the URL");
      }
    };

    getCodeFromURL();
  }, [
    location?.search,
    code,
    REACT_APP_AUTH_PAGE_URL,
    REACT_APP_STATIC_PAGE_URL,
  ]);
  const prevPassWordRef = useRef();
  const prevEmailRef = useRef();
  useEffect(() => {
    prevPassWordRef.current = state.password;
    prevEmailRef.current = state.email;
  }, [state.password, state.email]);

  const handleLogin = async () => {
    let isValid = true;
    let localState = state;
    const emailValidation = validateEmail(state.email);
    let isValidEmail;
    let isValidPassword;
    let isChecked;
    if (!emailValidation.isValid) {
      isValid = false;
      isValidEmail = true;
    }

    const passwordValidation = validatePassword(state.password);
    if (!passwordValidation.isValid) {
      isValid = false;
      isValidPassword = true;
    }
    if (!check) {
      isValid = false;
      isChecked = true;
    }

    setState({
      ...state,
      emailError: isValidEmail ? emailValidation?.message : "",
      passwordError: isValidPassword ? passwordValidation?.message : "",
      checkError: isChecked ? "Please Agree the Terms & Conditions" : "",
    });

    if (isValid) {
      if (!state.emailError?.length > 0 && !state.passwordError?.length) {
        setLoading(true);
        const hashedPassword = await encrypt(state.password);
        let { data, status } = await request.post(`/user/signin`, {
          email: state.email,
          password: hashedPassword,
        });
        if (status >= 400) {
          if (data.message.includes("password")) {
            setState({
              ...state,
              passwordError: data.message,
            });
          }
          if (data.message.includes('body/email must match format "email"')) {
            setState({
              ...state,
              emailError: "Enter valid email Id.",
            });
            toast.error("Enter valid email Id.");
          } else if (data.message.includes(state.email)) {
            toast.error(data.message);
            setState({
              ...state,
              emailError: data.message,
            });
          } else {
            toast.error(data.message);
          }
        }
        if (status >= 200 && status < 300) {
          // Check for multi-account response
          if (data?.data?.multipleAccounts) {
            setMultiAccountData({
              accounts: data.data.accounts,
              sessionToken: data.data.sessionToken,
              email: state.email,
            });
          } else {
            let redirectionLink = data?.data?.redirectLink;
            if (NODE_ENV === "development") {
              let link = getDevAppLink(redirectionLink);
              if (link) {
                redirectionLink = link;
              }
            }
            toast.success("Successfully signed in, redirecting...");
            window.open(redirectionLink, "_self");
          }
        }
        setLoading(false);
      } else {
        setState(localState);
      }
    }
  };

  const onChangeChecked = () => {
    setState({ ...state, checkError: "" });
    setCheck(!check);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  const handleGoogleSignInClick = () => {
    const authorizationUrl =
      REACT_APP_GOOGLE_AUTH_URL +
      `?client_id=${REACT_APP_GOOGLE_CLIENT_ID}` +
      `&redirect_uri=${REACT_APP_AUTH_PAGE_URL}` +
      "&response_type=code" +
      "&scope=openid%20email%20profile%20phone";

    window.location.href = authorizationUrl;
  };

  // If multi-account response received, show account selector
  if (multiAccountData) {
    return (
      <AccountSelector
        accounts={multiAccountData.accounts}
        sessionToken={multiAccountData.sessionToken}
        email={multiAccountData.email}
        onBack={() => {
          setMultiAccountData(null);
          setState({ ...state, password: "", passwordError: "" });
        }}
      />
    );
  }

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to access your account."
      after={
        <>
          <p className="signup-line">
            New to PluginLive?{" "}
            <button type="button" className="link" aria-haspopup="dialog" onClick={() => setContactOpen(true)}>
              Contact us
            </button>
          </p>
          <ContactDialog open={contactOpen} onClose={() => setContactOpen(false)} />
        </>
      }
    >
      <button
        type="button"
        onClick={handleGoogleSignInClick}
        className="auth-btn auth-btn-outline auth-btn-block"
        id="google-signin-button"
        disabled={loading}
      >
        <img src={Google} alt="" aria-hidden="true" />
        Continue with Google
      </button>

      <div className="auth-or">or sign in with email</div>
      <EmailField
        value={state.email}
        error={state.emailError}
        onChange={(value) => handleState(value, "email")}
        onKeyDown={handleKeyPress}
      />
      <PasswordField
        id="psw"
        label="Password"
        value={state.password}
        error={state.passwordError}
        onChange={(value) => handleState(value, "password")}
        onKeyDown={handleKeyPress}
      />
      <div className="options">
        {/* ponytail: UI only. /user/signin has no "remember me" field and the session
            length is set by the backend's redirect token, so this changes nothing yet.
            Upgrade: send `rememberMe` with the sign-in request and have the API issue a
            longer-lived session when it's true. */}
        <label className="auth-check">
          <input type="checkbox" checked={remember} onChange={(e) => setRemember(e.target.checked)} />
          Remember me
        </label>
        <button type="button" className="link" onClick={() => history.push("/forgot")}>
          Forgot password?
        </button>
      </div>

      <button
        type="button"
        onClick={handleLogin}
        className="auth-btn auth-btn-primary auth-btn-block"
        disabled={loading}
      >
        {loading ? "Signing in…" : "Sign in"}
        {!loading && ARROW}
      </button>


      <div className="terms-line">
        By signing in, you agree to our{" "}
        <TermsLink />
      </div>
    </AuthLayout>
  );
};

const ARROW = <Icon name="arrow-forward" />;

export default Login;
